import { HttpHeaders } from '@angular/common/http';
import { ILooseObject } from '../interfaces';

// API Paths constants
export const ADDITIVES_PATH = 'additives';
export const ALLERGENS_PATH = 'allergens';
export const APP_UPDATES_PATH = 'app-updates';
export const AVAILABLE_TIMES_PATH = 'available-times';
export const CART_ITEMS_PATH = 'cart-items';
export const CATEGORIES_PATH = 'categories';
export const COUNTRIES_PATH = 'countries';
export const DIETARY_PREFERENCES_PATH = 'dietary-preferences';
export const DEVICES_PATH = 'devices';
export const MENUS_PATH = 'menus';
export const PRODUCT_CATEGORIES_PATH = 'product-categories';
export const IMAGES_PATH = 'images';
export const INGREDIENTS_PATH = 'ingredients';
export const LOCALES_PATH = 'locales';
export const ORDERS_PATH = 'orders';
export const SUBORDERS_PATH = 'suborders';
export const STOCK_ITEMS_PATH = 'stock-items';
export const STOCK_MOVEMENTS_PATH = 'stock-movements';
export const RECIPE_ITEM_DRAFTS_PATH = 'recipe-item-drafts';
export const RECIPE_ITEMS_PATH = 'recipe-items';
export const RECIPE_CATEGORIES_PATH = 'recipe-categories';
export const DIRECT_SALE_PATH = 'direct-sale';
export const DIRECT_SALE_DINE_IN_PATH = `${DIRECT_SALE_PATH}/dine-in`;
export const DIRECT_SALE_TAKEAWAY_PATH = `${DIRECT_SALE_PATH}/takeaway`;
export const PRODUCTS_PATH = 'product-items';
export const PRODUCT_ITEM_DRAFTS_PATH = 'product-item-drafts';
export const RESTRICTIONS_PATH = 'restrictions';
export const RESERVATIONS_PATH = 'reservations';
export const VENUES_PATH = 'venues';
export const PASSWORD = 'password';
export const SESSIONS_PATH = 'sessions';
export const SIZES_PATH = 'sizes';
export const TERMS_PATH = 'terms';
export const CURRENT_PATH = `/current`;
export const USERS_PATH = 'users';
export const NOTIFICATIONS_PATH = 'notifications';
export const TABLES_PATH = 'tables';
export const SPACES_PATH = 'spaces';
export const IMPORT_TABLES_PATH = 'import';
export const WAITER_COMMANDS_PATH = 'waiter-commands';
export const WAITER_COMMANDS_OPTIONS_PATH = 'waiter-command-options';
export const WAITER_COMMANDS_ACCEPT = 'accept';
export const FINGERPRINT_PATH = 'fingerprint';
export const PAYMENTS_PATH = 'payments';
export const PAYMENT_METHODS_PATH = 'payment-methods';
export const REPORTS_PATH = 'reports';
export const COMPARISON_PATH = 'comparison';
export const PERIOD_PATH = 'period';
export const WAITERS_PATH = 'waiters';
export const AUTH_PATH = 'auth';
export const DOWNLOAD_PATH = 'download';
export const ONBOARDING_PATH = 'onboarding';
export const RESET_PASSWORD_REQUEST = 'reset-password-request';
export const RESET_PASSWORD = 'reset-password';
export const REGISTER_MANAGER_PATH = 'register-manager';
export const CHECK_AWAITING_MANAGER_PATH = 'check-awaiting-manager';
export const CONFIRM_MANAGER_PATH = 'confirm-manager';
export const REQUEST_PHONE_VERIFICATION_PATH = 'request-phone-verification';
export const VERIFY_PHONE_CODE_PATH = 'verify-phone-code';

// Local storage keys
export const LOCALE_KEY = 'locale';
export const ONBOARDING_PROGRESS_STORAGE_KEY = 'onboardingProgress';
export const PREFERRED_GRID_VIEW = 'preferredGridView';
export const PREFERRED_VENUE_ID_KEY = 'preferredVenueIdKey';
export const PREFERRED_REPORTS_PERIOD_KEY = 'preferredReportsPeriod';
export const PREFERRED_REPORTS_DATE_RANGE_KEY = 'preferredReportsDateRange';
export const USER_KEY = 'user';
export const USER_JWT_KEY = 'userJWT';
export const USER_ACCOUNT_TYPE = 'userAccountType';

// Other constants
export const AnimationOutTiming = 300;
export const POS = 'POS';
export const QR = 'QR';
export const PAGE = 'PAGE';
export const WAYTR = 'WAYTR';
export const WAYTR_CUSTOM_ALPHABET = 'abcdefghijklmnopqrstuvwxyz';
export const WAYTR_CUSTOM_ALPHABET_WITH_NUMBERS_AND_UPPERCASE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
export const WAYTR_DOMAIN = 'waytr.app';
export const WAYTR_CDN = 'https://cdn.waytr.app';
export const FALLBACK_IMAGE =
  'data:image/png;base64,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';
export const FISCAL_NET_HOST = 'http://localhost:65400/api/Receipt';

// Tree list constants
export const UNCATEGORIZED_CATEGORY_KEY = 'uncategorized';

// Types
export type ExcludedParams = '_id' | '_v' | 'createdAt' | 'updatedAt';

// Enums
export enum DatabaseOperations {
  INSERT = 'insert',
  DELETE = 'delete',
  UPDATE = 'update',
}

// Http Headers
export const httpOptions: ILooseObject = {
  headers: new HttpHeaders({
    accept: 'application/json',
  }),
};

export const imageHttpOptions: ILooseObject = {
  responseType: 'blob',
  headers: new HttpHeaders({
    accept: 'image/webp',
  }),
};

export const WaiterCommandsParametersEnum = {
  STATUS: 'status',
};
